export const TDB_MARKET_KEY = "test-drive-mkt";
export const TDB_LANGUAGE_KEY = "test-drive-lang";
export const SUPPORTED_LANGUAGES = [ "en", "es" ];
export const DEFAULT_LANGUAGE = "en";